import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const AlertModule = props => (
    <SvgIcon {...props}>
        <path
            d="M9.761.761l6.241 10.909v2.603c0 .954-.773 1.727-1.727 1.727H1.1a.5.5 0 01-.435-.747L8.893.763A.5.5 0 019.76.76zm-.366 12.476a.92.92 0 100 1.842.92.92 0 000-1.842zm.26-7.596h-.558a.576.576 0 00-.536.59l.36 5.194a.463.463 0 00.921.024l.363-5.233a.576.576 0 00-.55-.575z"
            fillRule="evenodd"
            stroke="none"
        />
    </SvgIcon>
);

export default AlertModule;
